import {
  classNameParkerPrefix as prefixPk,
  classNamePrefix as prefixCt,
} from "@/utils/common";
import "../index.less";
import "./index.less";

const isContainsByTags = (node, tags) => {
  let { parentNode } = node;
  while (parentNode && parentNode.className !== prefixPk("view-container")) {
    if (tags.includes((parentNode.tagName || "").toLowerCase())) {
      return parentNode;
    }
    parentNode = parentNode.parentNode;
  }
  return false;
};

export default class imageRender {
  fragmentCls: string;

  config: Record<string, any>;

  hasLinkImage: boolean;

  constructor(config = {}) {
    this.fragmentCls = `.${prefixCt("image")}`;
    this.config = config;
    this.hasLinkImage = false;
  }

  fragmentRender = (node: HTMLElement) => {
    if (node.querySelector("img").getAttribute("data-link")) {
      this.hasLinkImage = true;
    }
  };

  containerRender = ($container: HTMLElement, config) => {
    if (this.hasLinkImage) {
      $container.addEventListener("click", this.handleImageLink);
    }
    const imgs = $container.querySelectorAll(`.${prefixCt("image")}>img`);
    const maxWidth = config.maxWidth || window.innerWidth;
    Array.from(imgs).forEach((img: any) => {
      if (!img.hasAttribute("data-src")) return;

      const dataWidth = parseInt(img.getAttribute("data-width"), 10);
      const parentNodeWithTable = isContainsByTags(img, ["td", "th"]);

      if (parentNodeWithTable || !dataWidth) {
        img.parentNode.style.cssText = "max-width: 100%";
      }

      if (dataWidth < maxWidth) {
        img.width = dataWidth;
        img.parentNode.style.cssText = `width: ${dataWidth}px`;
      } else {
        img.parentNode.style.cssText = "width: 100%;";
      }

      // 懒加载则先不设置src
      if (!config.lazyload) {
        img.src = img.getAttribute("data-src");
      }
      img.onerror = (e) => {
        e.target.classList.add(prefixCt("img-failed"));
      };
    });
  };

  handleImageLink = ({ target }) => {
    const $span = target.closest(this.fragmentCls);
    if ($span && target.getAttribute("data-link")) {
      window.open(target.getAttribute("data-link"));
    }
  };
}
